import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'company-beneficialowner-form',
    templateUrl: './company-beneficialowner-form.component.html',
    styleUrls: ['./company-beneficialowner-form.component.scss'],
    standalone: false
})
export class CompanyBeneficialownerFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
